import { IconProp } from "@fortawesome/fontawesome-svg-core"

import { faIcon } from "@utils/faIcon"

import { ObjectsViewType } from "@organisms/ObjectsView/ObjectsView.types"

export const OBJECTS_VIEW_ICONS: Record<ObjectsViewType, { inactive: IconProp; active: IconProp }> = {
    table: {
        inactive: faIcon({ name: "table", style: "regular" }),
        active: faIcon({ name: "table", style: "solid" }),
    },
    card: {
        inactive: faIcon({ name: "grid-2", style: "regular" }),
        active: faIcon({ name: "grid-2", style: "solid" }),
    },
    timeline: {
        inactive: faIcon({ name: "regular-timeline-view", style: "kit" }),
        active: faIcon({ name: "solid-timeline-view", style: "kit" }),
    },
}
